import React, { Component, Fragment } from "react";
import moment from "moment";
import { withRouter } from "react-router-dom";
import Button from "../../components/Button/Button";
import StackedBarChart from "../../components/Charts/StackedBarChart";
import ContentLoader from "../../components/Loader/Loader";
//import Autocomplete from "react-autocomplete";

import { dateFormat } from "../../utils/utils";

//import { getValue } from "../../utils/sessionManager";
//import { getScheme } from "../../action/FundComparison";
import SingleLineChart from "../../components/Charts/SingleLineChart";
import BlockUi from "react-block-ui";

import Seo from "./Seo";
//import Footer from "./Footer";

import {
  getFundsMetaData,
  getSectorsHoldingMF,
  getSecurityHoldingMF,
  getKeyQuants,
  getCrntFundsAnalysis,
  getRemainingFundsAnalysis,
} from "../../action/ClientDashboardActions";
import {
  getAuthToken,
  getTopSecurities,
  getAnalyticalData,
  getNavHistory,
} from "../../action/FundComparison";

class FundDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      testdata: [],
      portfolioYears: [],
      AuthTokenRes: "",
      marketCapDataList: [],
      topStockHoldings: [],
      schemeCode: "",
      fundDetails: [],
      key_quants: [],
      security_holding_mf_list: [],
      sector_holding_mf_list: [],
      yearRange: 3,
      yearsMonthRange: "1Y",
      frequency: "week",
      yearsRatio: "1y",
      absoluteReturnXAxis: [
        "x",
        "2013",
        "2014",
        "2015",
        "2016",
        "2017",
        "2018",
        "2019",
      ],
      absoluteReturnYAxis: ["years", 30, 200, 100, 400, 150, 250, 250],
      investmentValue: 100000,
      investmentValueRecurring: 0,
      investmentPerformanceData: [],
      absolute_return_category: [],
      absolute_return_y_axis: [],
      absoluteReturnRange: "annual",
      fetching: false,
      // investmentSchemeCode: "",
      isLoading: false,
      totalInvestValue: 0,
      // mutual_funds: [],
      // searchSchemeText: "",
      // scheme_error: "",
    };
  }

  getInvestmentPerformance = async () => {
    const { investmentValue, investmentValueRecurring } = this.state;
    this.setState({
      investmentPerformanceData: [],
    });
    //const fundsSchemeCodeList = ["112323"];
    const yearsRange = this.state.yearRange;
    const toYears = moment().subtract(1, "month").format("YYYY-MM");
    const fromYears = moment(toYears)
      .subtract(yearsRange, "years")
      .format("YYYY-MM");
    const Res1 = await getCrntFundsAnalysis(
      this.state.schemeCode,
      Number(investmentValue),
      Number(investmentValueRecurring),
      // this.state.investmentValue,
      // this.state.investmentValueRecurring,
      toYears,
      fromYears
    );
    const benchmarkCode =
      Res1.data.data.scheme[this.state.schemeCode]["benchmark_code"];
    const Res2 = await getRemainingFundsAnalysis(
      this.state.schemeCode,
      Number(investmentValue),
      Number(investmentValueRecurring),
      // this.state.investmentValue,
      // this.state.investmentValueRecurring,
      toYears,
      fromYears,
      benchmarkCode
    );

    this.setState({
      investmentPerformanceData: [
        "Return",
        Res2.data.data["SB"].values[toYears] !== null
          ? Res2.data.data["SB"].values[toYears].toFixed("0")
          : null,
        Res2.data.data["FD"].values[toYears] !== null
          ? Res2.data.data["FD"].values[toYears].toFixed("0")
          : null,
        Res2.data.data.benchmark[benchmarkCode].values[toYears] !== null
          ? Res2.data.data.benchmark[benchmarkCode].values[toYears].toFixed("0")
          : null,
        Res1.data.data.portfolio.values[toYears] !== null
          ? Res1.data.data.portfolio.values[toYears].toFixed("0")
          : null,
      ],
      // investmentPerformanceChartDataFetching: true,
    });
  };

  getInitialFundDetailsData = async () => {
    try {
      const { schemeCode } = this.state;
      const date = moment().subtract(1, "days").format("YYYY-MM-DD");
      const fundDetails = await getFundsMetaData(schemeCode, date);
      const sectorsHoldingMFRes = await getSectorsHoldingMF(schemeCode);
      const securitysHoldingMFRes = await getSecurityHoldingMF(schemeCode);
      const keyQuantsRes = await getKeyQuants(schemeCode);
      const res1 = fundDetails.data;
      const res2 = sectorsHoldingMFRes.data;
      const res3 = securitysHoldingMFRes.data;
      const res4 = keyQuantsRes.data;
      this.setState(
        {
          fundDetails: res1.data,
          sector_holding_mf_list: res2.data.splice(0, 5),
          security_holding_mf_list: res3.data.splice(0, 5),
          key_quants: res4.data[schemeCode],
          fetching: true,
        },
        () => {
          this.setAbsoluteReturnData();
        }
      );
    } catch (err) {
      console.error("getInitialFundDetailsData, Server err: ", err.response);
      const data = err.response.data;
      this.setState({ server_error: data.error });
    }
  };

  setAbsoluteReturnData = () => {
    const { fundDetails, absoluteReturnRange } = this.state;
    const category = [];
    const dataSet = [];
    switch (absoluteReturnRange) {
      case "annual":
        dataSet.push(["annual"]);
        break;
      case "bi-annual":
        dataSet.push(["H1"], ["H2"]);
        break;
      case "quarterly":
        dataSet.push(["Q1"], ["Q2"], ["Q3"], ["Q4"]);
        break;
      default:
        return "foo";
    }
    const annualReturns = fundDetails.annual_returns;
    for (var key in annualReturns) {
      if (annualReturns.hasOwnProperty(key)) {
        category.push(key);
        switch (absoluteReturnRange) {
          case "annual":
            dataSet[0].push(annualReturns[key][absoluteReturnRange]);
            break;
          case "bi-annual":
            annualReturns[key]["H1"] !== undefined
              ? dataSet[0].push(annualReturns[key]["H1"])
              : dataSet[0].push(null);
            annualReturns[key]["H2"] !== undefined
              ? dataSet[1].push(annualReturns[key]["H2"])
              : dataSet[1].push(null);
            break;
          case "quarterly":
            annualReturns[key]["Q1"] !== undefined
              ? dataSet[0].push(annualReturns[key]["Q1"])
              : dataSet[0].push(null);
            annualReturns[key]["Q2"] !== undefined
              ? dataSet[1].push(annualReturns[key]["Q2"])
              : dataSet[1].push(null);
            annualReturns[key]["Q3"] !== undefined
              ? dataSet[2].push(annualReturns[key]["Q3"])
              : dataSet[2].push(null);
            annualReturns[key]["Q4"] !== undefined
              ? dataSet[3].push(annualReturns[key]["Q4"])
              : dataSet[3].push(null);
            break;
          default:
            return "foo";
        }
      }
    }
    this.setState({
      absolute_return_category: category,
      absolute_return_y_axis: dataSet,
    });
  };

  getTopHolding = async () => {
    const { schemeCode, AuthTokenRes } = this.state;
    const fromYears = moment().subtract(1, "day").format("YYYY-MM-DD");

    let values = {
      auth: AuthTokenRes,
      ranges: "1Y,3Y,5Y,7Y,10Y",
      from: fromYears,
      scheme_code: schemeCode,
    };
    let promise1 = await getAnalyticalData(values);
    let promise2 = await getTopSecurities(values);

    try {
      const res = await Promise.all([promise1, promise2]);
      //console.log(res);
      const resData = res[1].data.data.splice(0, 5);
      let marketCapDataList = res[0].data.data[schemeCode];
      this.setState({ topStockHoldings: resData, marketCapDataList });
    } catch (err) {
      console.error("getTopHolding, Server err: ", err.response);
      const data = err.response.data;
      this.setState({ server_error: data.error });
    }
  };

  getToken = async () => {
    try {
      const tokenRes = await getAuthToken();
      const res = tokenRes.data;
      this.setState({ AuthTokenRes: res.data.auth }, () =>
        this.getTopHolding()
      );
    } catch (err) {
      console.error("handleToken, Server err: ", err.response);
      const data = err.response.data;
      this.setState({ server_error: data.error });
    }
  };
  getNavHistory = async () => {
    const { frequency, schemeCode } = this.state;
    //console.log("100119",schemeCode)
    let values = {
      schemeCode: schemeCode,
      fromYears: "2019-01-01",
      toYears: "2020-11-27",
      frequency: frequency,
    };
    try {
      const res = await getNavHistory(values);
      let testdata = ["portfolio"];
      let portfolioYears = ["x1"];
      let resData = res.data.data.nav_history;

      Object.keys(resData).forEach((key) => {
        portfolioYears.push(dateFormat(key, "YYYY-MM-DD"));
        testdata.push(resData[key]);
      });
      this.setState({
        testdata,
        portfolioYears,
      });
    } catch (err) {
      console.error("getNavHistory, Server err: ", err.response);
      const data = err.response.data;
      this.setState({ server_error: data.error });
    }
  };

  // getFunds = async () => {
  //   const { searchSchemeText, optionName } = this.state;
  //   if (searchSchemeText === "") {
  //     this.setState({ mutual_funds: [] }); // reset it
  //   }
  //   try {
  //     if (searchSchemeText.length >= 3) {
  //       const schemeRes = await getScheme(searchSchemeText, optionName);
  //       const res = schemeRes.data;
  //       this.setState({ mutual_funds: res.data.mutual_funds });
  //     }
  //   } catch (err) {
  //     console.error("getScheme, Server err: ", err.response);
  //     const data = err.response.data;
  //     this.setState({ server_error: data.error });
  //   }
  // };

  componentDidMount = () => {
    // const user = getValue("user");
    const queryString = this.props.location.pathname.split("/");
    let schemeCode = queryString[3];
    //  console.log(queryString,this.props.schemeCode)
    this.setState(
      {
        // user: user.username,
        schemeCode,
      },
      () => {
        this.getToken();
        this.getInitialFundDetailsData();
        this.getInvestmentPerformance();
        this.setAbsoluteReturnData();
        this.getNavHistory();
        this.handleTotalCost();
      }
    );
  };

  handleInvestmentValue = (e) => {
    this.setState({ investmentValue: e.target.value }, () => {
      this.getInvestmentPerformance();
      this.handleTotalCost();
    });
  };
  handleInvestmentRecurringvalue = (e) => {
    this.setState({ investmentValueRecurring: e.target.value }, () => {
      this.getInvestmentPerformance();
      this.handleTotalCost();
    });
  };
  handleAbsoluteYearsRange = (range) => {
    this.setState({ absoluteReturnRange: range }, () =>
      this.setAbsoluteReturnData()
    );
  };

  handleInvestmentYearsRange = (years) => {
    this.setState({ yearRange: years }, () => {
      this.getInvestmentPerformance();
      this.handleTotalCost();
    });
  };
  // handleSelectedFundSchemeCode = (fund) => {
  //   this.setState({ investmentSchemeCode: fund.scheme_code });
  // };
  handleInvestmentMonth = (month, frequency) => {
    this.setState(
      {
        yearsMonthRange: month,
        frequency,
      },
      () => this.getNavHistory()
    );
  };

  handleInvestmentYearsRatios = (Ratio) => {
    this.setState({ yearsRatio: Ratio });
  };

  handleTotalCost = () => {
    const { investmentValue, investmentValueRecurring, yearRange } = this.state;
    let totalInvestValue = 0;
    if (Number(investmentValueRecurring) > 0) {
      let totalSipValue =
        Number(investmentValueRecurring) * (Number(yearRange) * 12);
      totalInvestValue = Number(investmentValue) + totalSipValue;
    } else {
      totalInvestValue = Number(investmentValue);
    }
    this.setState({ totalInvestValue });
  };

  // handleSearchScheme = (e) => {
  //   const value = e.target.value;
  //   this.setState({ searchSchemeText: value }, () => this.getFunds());
  // };

  handleSelectedScheme = (value, item) => {
    this.setState(
      {
        schemeCode: item.scheme_code,
        showFundDetailsPage: true,
      },
      () => {
        this.getToken();
        this.getInitialFundDetailsData();
        this.getInvestmentPerformance();
        this.setAbsoluteReturnData();
        this.getNavHistory();
        this.handleTotalCost();
      }
    );
  };

  render() {
    const {
      testdata,
      portfolioYears,
      fundDetails,
      key_quants,
      yearRange,
      yearsMonthRange,
      yearsRatio,
      security_holding_mf_list,
      sector_holding_mf_list,
      investmentPerformanceData,
      investmentValue,
      investmentValueRecurring,
      absolute_return_category,
      absolute_return_y_axis,
      absoluteReturnRange,
      fetching,
      // showToolTip,
      //   investmentSchemeCode,
      topStockHoldings,
      marketCapDataList,
      isLoading,
      totalInvestValue,
      // mutual_funds,
      // searchSchemeText,
      // scheme_error,
    } = this.state;
    return (
      <Fragment>
        <BlockUi tag="div" blocking={isLoading}>
          <div id="fund_details_page bg_fund">
            {/* <div className="row justify-content-center">
              <div className="col-md-8 mt-5 ">
                <div className="form-group has-search al_auto_search al_auto_search_1">
                  <i className="fa fa-search form-control-search"></i>
                  <Autocomplete
                    inputProps={{
                      placeholder: "search any mutual fund",
                    }}
                    getItemValue={(item) => item.scheme_name_unique}
                    items={mutual_funds}
                    renderItem={(item, isHighlighted) => (
                      <div
                        key={item.scheme_name_unique}
                        style={{
                          background: isHighlighted ? "lightgray" : "white",
                          cursor: "pointer",
                        }}
                      >
                        {item.scheme_name_unique}
                      </div>
                    )}
                    value={searchSchemeText}
                    onChange={(e) => this.handleSearchScheme(e)}
                    onSelect={(value, item) =>
                      this.handleSelectedScheme(value, item)
                    }
                  />
                  <div className="input-error">{scheme_error}</div>
                </div>
              </div>
            </div> */}
            {fetching && (
              <Fragment>
                <div className="container-fluid p-5 text-left">
                  <div className="row mt-5">
                    <div className="col-sm-8">
                      <h1 className="title_2">
                        {fundDetails.general_info.scheme_name}
                      </h1>
                    </div>
                  </div>
                  <div className="row text-left">
                    <div className="col-sm-12">
                      <span className="subtitle_1 mr-1">
                        {fundDetails.metadata.asset_sub_category}
                      </span>
                      <span className="subtitle_1">
                        {fundDetails.metadata.asset_category}
                      </span>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-12">
                      <div className="card al_card al_card_2">
                        <div className="card-header title_6">
                          Scheme Information
                        </div>
                        <div className="card-body">
                          <div className="d-inline-block w-20">
                            <p className="data_1 mb-0">
                              {fundDetails.metadata.date_of_inception}
                            </p>
                            <p className="header_1">Launch Date</p>
                          </div>
                          <div className="d-inline-block w-20">
                            <p className="data_1 mb-0">
                              {fundDetails.metadata.fund_size} Cr
                            </p>
                            <p className="header_1">Fund Size</p>
                          </div>
                          <div className="d-inline-block w-20">
                            <p className="data_1 mb-0">
                              {fundDetails.metadata.fund_manager}
                            </p>
                            <p className="header_1">Fund Manager</p>
                          </div>
                          <div className="d-inline-block w-20">
                            <p className="data_1 mb-0">
                              {fundDetails.metadata.risk_profile}
                            </p>
                            <p className="header_1 ">Risk Profile</p>
                          </div>
                          <div className="d-inline-block w-20">
                            <p className="data_1 mb-0">
                              {fundDetails.metadata.benchmark}
                            </p>
                            <p className="header_1">Benchmark</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-12">
                      <div className="card al_card al_card_2">
                        <div className="card-header title_6">NAV Graph </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-sm-7">
                              <div className="row par_7">
                                {yearsMonthRange === "1M" && (
                                  <Fragment>
                                    <p className="col-sm-2">
                                      {fundDetails.mf_trailing[0] !== undefined
                                        ? fundDetails.mf_trailing[0]["1M"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.bm_trailing[0] !== undefined
                                        ? fundDetails.bm_trailing[0]["1M"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["1M"] !== undefined
                                        ? fundDetails.topcharts["1M"].rank
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["1M"][
                                        "category_avg"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["1M"][
                                        "best"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["1M"][
                                        "worst"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                  </Fragment>
                                )}
                                {yearsMonthRange === "3M" && (
                                  <Fragment>
                                    <p className="col-sm-2">
                                      {fundDetails.mf_trailing[1] !== undefined
                                        ? fundDetails.mf_trailing[1]["3M"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.bm_trailing[1] !== undefined
                                        ? fundDetails.bm_trailing[1]["3M"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["3M"] !== undefined
                                        ? fundDetails.topcharts["3M"].rank
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["3M"][
                                        "category_avg"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["3M"][
                                        "best"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["3M"][
                                        "worst"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                  </Fragment>
                                )}
                                {yearsMonthRange === "6M" && (
                                  <Fragment>
                                    <p className="col-sm-2">
                                      {fundDetails.mf_trailing[2] !== undefined
                                        ? fundDetails.mf_trailing[2]["6M"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.bm_trailing[2] !== undefined
                                        ? fundDetails.bm_trailing[2]["6M"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["6M"] !== undefined
                                        ? fundDetails.topcharts["6M"].rank
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["6M"][
                                        "category_avg"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["6M"][
                                        "best"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["6M"][
                                        "worst"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                  </Fragment>
                                )}

                                {yearsMonthRange === "1Y" && (
                                  <Fragment>
                                    <p className="col-sm-2">
                                      {fundDetails.mf_trailing[3] !== undefined
                                        ? fundDetails.mf_trailing[3]["1Y"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.bm_trailing[3] !== undefined
                                        ? fundDetails.bm_trailing[3]["1Y"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["1Y"] !== undefined
                                        ? fundDetails.topcharts["1Y"].rank
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["1Y"][
                                        "category_avg"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["1Y"][
                                        "best"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["1Y"][
                                        "worst"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                  </Fragment>
                                )}
                                {yearsMonthRange === "3Y" && (
                                  <Fragment>
                                    <p className="col-sm-2">
                                      {fundDetails.mf_trailing[4] !== undefined
                                        ? fundDetails.mf_trailing[4]["3Y"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.bm_trailing[4] !== undefined
                                        ? fundDetails.bm_trailing[4]["3Y"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["3Y"] !== undefined
                                        ? fundDetails.topcharts["3Y"].rank
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["3Y"][
                                        "category_avg"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["3Y"][
                                        "best"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["3Y"][
                                        "worst"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                  </Fragment>
                                )}
                                {yearsMonthRange === "5Y" && (
                                  <Fragment>
                                    <p className="col-sm-2">
                                      {fundDetails.mf_trailing[5] !== undefined
                                        ? fundDetails.mf_trailing[5]["5Y"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.bm_trailing[5] !== undefined
                                        ? fundDetails.bm_trailing[5]["5Y"] + "%"
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["5Y"] !== undefined
                                        ? fundDetails.topcharts["5Y"].rank
                                        : "NA"}
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["5Y"][
                                        "category_avg"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["5Y"][
                                        "best"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                    <p className="col-sm-2">
                                      {fundDetails.topcharts["5Y"][
                                        "worst"
                                      ].toFixed("0")}
                                      %
                                    </p>
                                  </Fragment>
                                )}
                              </div>
                              <div className="row header_1">
                                <p className="col-sm-2">This Fund</p>
                                <p className="col-sm-2">Benchmark </p>
                                <p className="col-sm-2">Rank in Cat.</p>
                                <p className="col-sm-2">Cat. Average </p>
                                <p className="col-sm-2">Cat. Best</p>
                                <p className="col-sm-2">Cat. Worst </p>
                              </div>
                            </div>
                            <div className="col-sm-5 text-right">
                              <div className="btn-group">
                                <Button
                                  type="button"
                                  text="1m"
                                  size="md"
                                  isLoading={false}
                                  customClass={`btn border-warning ${
                                    yearsMonthRange === "1M"
                                      ? "al_button_01 "
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.handleInvestmentMonth("1M", "day")
                                  }
                                />
                                <Button
                                  type="button"
                                  text="3m"
                                  size="md"
                                  isLoading={false}
                                  customClass={`btn border-warning ${
                                    yearsMonthRange === "3M"
                                      ? "al_button_01 "
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.handleInvestmentMonth("3M", "day")
                                  }
                                />
                                <Button
                                  type="button"
                                  text="6m"
                                  size="md"
                                  isLoading={false}
                                  customClass={`btn border-warning ${
                                    yearsMonthRange === "6M"
                                      ? "al_button_01 "
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.handleInvestmentMonth("6M", "day")
                                  }
                                />
                                <Button
                                  type="button"
                                  text="1y"
                                  size="md"
                                  isLoading={false}
                                  customClass={`btn border-warning ${
                                    yearsMonthRange === "1Y"
                                      ? "al_button_01 "
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.handleInvestmentMonth("1Y", "week")
                                  }
                                />
                                <Button
                                  type="button"
                                  text="3y"
                                  size="md"
                                  isLoading={false}
                                  customClass={`btn border-warning ${
                                    yearsMonthRange === "3Y"
                                      ? "al_button_01 "
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.handleInvestmentMonth("3Y", "week")
                                  }
                                />
                                <Button
                                  type="button"
                                  text="5y"
                                  size="md"
                                  isLoading={false}
                                  customClass={`btn border-warning ${
                                    yearsMonthRange === "5Y"
                                      ? "al_button_01 "
                                      : ""
                                  }`}
                                  onClick={() =>
                                    this.handleInvestmentMonth("5Y", "week")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="row mt-4">
                            {testdata.length > 0 && (
                              <SingleLineChart
                                chartId={"demo"}
                                chartData={""}
                                isYAxis={false}
                                isXAxis={false}
                                xAxisCategory1={portfolioYears}
                                data1={testdata}
                                dataCategory1={"portfolio"}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-12">
                      <div className="card al_card al_card_2">
                        <div className="card-header title_6">Key Quants</div>
                        <div className="card-body">
                          <div className="d-inline-block w-20">
                            <p className="data_1 mb-0">
                              {key_quants.portfolio_turnover_ratio.toFixed("0")}
                            </p>
                            <p className="header_1">Turnover</p>
                          </div>
                          <div className="d-inline-block w-20">
                            <p className="data_1 mb-0">
                              {key_quants.pe_ratio.toFixed("0")}
                            </p>
                            <p className="header_1">P/E Ratio</p>
                          </div>
                          <div className="d-inline-block w-20">
                            <p className="data_1 mb-0">
                              {key_quants.yield_to_maturity === 0
                                ? "NA"
                                : key_quants.yield_to_maturity}
                            </p>
                            <p className="header_1">Yield To Maturity</p>
                          </div>
                          <div className="d-inline-block w-20">
                            <p className="data_1 mb-0">
                              {key_quants["average_maturity"][
                                "avg_maturity_years"
                              ] === 0
                                ? "NA"
                                : key_quants["average_maturity"][
                                    "avg_maturity_years"
                                  ]}
                            </p>
                            <p className="header_1">Average Maturity(years)</p>
                          </div>
                          <div className="d-inline-block w-20">
                            <p className="data_1 mb-0">
                              {key_quants["modified_duration"][
                                "modified_maturity_years"
                              ] === 0
                                ? "NA"
                                : key_quants["modified_duration"][
                                    "modified_maturity_years"
                                  ]}
                            </p>
                            <p className="header_1">Modified Duration(years)</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-12 ">
                      <div className="card al_card al_card_2 h-100">
                        <div className="card-header title_6">
                          Absolute Returns
                        </div>
                        <div className="card-body">
                          <StackedBarChart
                            chartId="absolute_return"
                            showLegend={false}
                            isYAxis={true}
                            xType={"category"}
                            xCategory={absolute_return_category}
                            barData={absolute_return_y_axis}
                            dataColor={{
                              annual: "#81cfe0",
                              H1: "#81cfe0",
                              H2: "#013243",
                              Q1: "#81cfe0",
                              Q2: "#013243",
                              Q3: "#6bb9f0",
                              Q4: "#5c97bf",
                            }}
                          />
                        </div>
                        <div className="row justify-content-center">
                          <div className="btn-group">
                            <Button
                              type="button"
                              text=" Annually"
                              customClass={`btn border-warning ${
                                absoluteReturnRange === "annual"
                                  ? "al_button_01"
                                  : ""
                              }`}
                              onClick={() =>
                                this.handleAbsoluteYearsRange("annual")
                              }
                            />
                            <Button
                              type="button"
                              text=" Bi Annually"
                              customClass={`btn border-warning ${
                                absoluteReturnRange === "bi-annual"
                                  ? "al_button_01"
                                  : ""
                              }`}
                              onClick={() =>
                                this.handleAbsoluteYearsRange("bi-annual")
                              }
                            />
                            <Button
                              type="button"
                              text=" Quarterly"
                              customClass={`btn border-warning ${
                                absoluteReturnRange === "quarterly"
                                  ? "al_button_01"
                                  : ""
                              }`}
                              onClick={() =>
                                this.handleAbsoluteYearsRange("quarterly")
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-12">
                      <div className="card al_card al_card_2">
                        <div className="card-header">
                          <div className="row">
                            <span className="title_6 p-2">
                              If you had invested
                            </span>
                            <span className="col-1">
                              <input
                                type="number"
                                value={investmentValue}
                                onChange={(e) => this.handleInvestmentValue(e)}
                                className="form-control par_7 border-white border-botom form_control_custom font-weight-normal"
                              />
                            </span>
                            <span className="title_6 p-2"> as Lumpsum and</span>
                            <span className="col-1">
                              <input
                                type="number"
                                value={investmentValueRecurring}
                                onChange={(e) =>
                                  this.handleInvestmentRecurringvalue(e)
                                }
                                className="form-control par_7 border-white form_control_custom font-weight-normal"
                              />
                            </span>
                            <span className="title_6 p-2"> as SIP</span>
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-sm-5 mt-4">
                              {/* <span className="text-info mt-3">This Fund</span> */}
                              <div className="row mt-1">
                                <span className="col-sm-4">This Fund</span>
                                {/* <div className="col-sm-8 text-right"> 70% </div> */}
                              </div>
                              <div className="progress display-inline-block">
                                <div
                                  className="progress-bar bg_danger"
                                  role="progressbar"
                                  style={{ width: 50 }}
                                ></div>
                              </div>
                              <div className="row mt-1">
                                <span className="col-sm-4">Benchmark</span>
                                {/* <div className="col-sm-8 text-right"> 20% </div> */}
                              </div>
                              <div className="progress display-inline-block">
                                <div
                                  className="progress-bar bg_success"
                                  role="progressbar"
                                  style={{ width: 50 }}
                                ></div>
                              </div>
                              <div className="row mt-1">
                                <span className="col-sm-4">
                                  Bank Fixed Deposit
                                </span>
                                {/* <div className="col-sm-8 text-right"> 40% </div> */}
                              </div>
                              <div className="progress display-inline-block">
                                <div
                                  className="progress-bar bg_warning"
                                  role="progressbar"
                                  style={{ width: 50 }}
                                ></div>
                              </div>
                              <div className="row mt-1">
                                <span className="col-sm-4">
                                  Savings Bank Account
                                </span>
                                {/* <div className="col-sm-8 text-right"> 50% </div> */}
                              </div>
                              <div className="progress display-inline-block">
                                <div
                                  className="progress-bar bg_info"
                                  role="progressbar"
                                  style={{ width: 50 }}
                                ></div>
                              </div>
                            </div>
                            <div className="col-sm-7">
                              <div className="row text-info">
                                {/* <p className="col-sm-4">Profit in %</p> */}
                                <p className="col-sm-4">Market Value</p>
                                <p className="col-sm-4">Total Cost</p>
                              </div>
                              <div className="row mt-2">
                                {/* <p className="col-sm-4">na</p> */}
                                <p className="col-sm-4">
                                  {investmentPerformanceData[4]}
                                </p>
                                <p className="col-sm-4">{totalInvestValue}</p>
                              </div>
                              <div className="row">
                                {/* <p className="col-sm-4">na</p> */}
                                <p className="col-sm-4">
                                  {investmentPerformanceData[3]}
                                </p>
                                <p className="col-sm-4">{totalInvestValue}</p>
                              </div>
                              <div className="row">
                                {/* <p className="col-sm-4">na</p> */}
                                <p className="col-sm-4">
                                  {investmentPerformanceData[2]}
                                </p>
                                <p className="col-sm-4">{totalInvestValue}</p>
                              </div>
                              <div className="row">
                                {/* <p className="col-sm-4">{Number(investmentPerformanceData[1])/totalInvestValue * 100}</p> */}
                                <p className="col-sm-4">
                                  {investmentPerformanceData[1]}
                                </p>
                                <p className="col-sm-4">{totalInvestValue}</p>
                              </div>
                            </div>
                          </div>
                          <div className="row justify-content-center mt-5">
                            <div className="btn-group">
                              <Button
                                type="button"
                                text="1Y"
                                customClass={`btn border-warning ${
                                  yearRange === 1 ? "al_button_01 " : ""
                                }`}
                                onClick={() =>
                                  this.handleInvestmentYearsRange(1)
                                }
                              />
                              <Button
                                type="button"
                                text="3Y"
                                customClass={`btn border-warning ${
                                  yearRange === 3 ? "al_button_01 " : ""
                                }`}
                                onClick={() =>
                                  this.handleInvestmentYearsRange(3)
                                }
                              />
                              <Button
                                type="button"
                                text="5Y"
                                customClass={`btn border-warning ${
                                  yearRange === 5 ? "al_button_01 " : ""
                                }`}
                                onClick={() =>
                                  this.handleInvestmentYearsRange(5)
                                }
                              />
                              <Button
                                type="button"
                                text="7Y"
                                customClass={`btn border-warning ${
                                  yearRange === 7 ? "al_button_01 " : ""
                                }`}
                                onClick={() =>
                                  this.handleInvestmentYearsRange(7)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col">
                      <div className="card al_card al_card_2">
                        <div className="card-header title_6">Risk Ratios</div>
                        <div className="card-body">
                          {yearsRatio === "1y" && (
                            <div className="row par_7">
                              <div className="col">
                                {fundDetails.risk_parameters["1Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["1Y"].annual_sd !==
                                  null
                                  ? fundDetails.risk_parameters[
                                      "1Y"
                                    ].annual_sd.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["1Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["1Y"].beta !== null
                                  ? fundDetails.risk_parameters[
                                      "1Y"
                                    ].beta.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["1Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["1Y"]
                                  .sharpe_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "1Y"
                                    ].sharpe_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["1Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["1Y"]
                                  .treynor_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "1Y"
                                    ].treynor_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["1Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["1Y"]
                                  .jensens_alpha !== null
                                  ? fundDetails.risk_parameters[
                                      "1Y"
                                    ].jensens_alpha.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["1Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["1Y"]
                                  .information_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "1Y"
                                    ].information_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["1Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["1Y"]
                                  .sortino_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "1Y"
                                    ].sortino_ratio.toFixed("0")
                                  : "NA"}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["1Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["1Y"].r_squared !==
                                  null
                                  ? fundDetails.risk_parameters[
                                      "1Y"
                                    ].r_squared.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                            </div>
                          )}
                          {yearsRatio === "3y" && (
                            <div className="row par_7">
                              <div className="col">
                                {fundDetails.risk_parameters["3Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["3Y"].annual_sd !==
                                  null
                                  ? fundDetails.risk_parameters[
                                      "3Y"
                                    ].annual_sd.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["3Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["3Y"].beta !== null
                                  ? fundDetails.risk_parameters[
                                      "3Y"
                                    ].beta.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["3Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["3Y"]
                                  .sharpe_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "3Y"
                                    ].sharpe_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["3Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["3Y"]
                                  .treynor_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "3Y"
                                    ].treynor_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["3Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["3Y"]
                                  .jensens_alpha !== null
                                  ? fundDetails.risk_parameters[
                                      "3Y"
                                    ].jensens_alpha.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["3Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["3Y"]
                                  .information_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "3Y"
                                    ].information_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["3Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["3Y"]
                                  .sortino_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "3Y"
                                    ].sortino_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["3Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["3Y"].r_squared !==
                                  null
                                  ? fundDetails.risk_parameters[
                                      "3Y"
                                    ].r_squared.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                            </div>
                          )}
                          {yearsRatio === "5y" && (
                            <div className="row par_7">
                              <div className="col">
                                {fundDetails.risk_parameters["5Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["5Y"].annual_sd !==
                                  null
                                  ? fundDetails.risk_parameters[
                                      "5Y"
                                    ].annual_sd.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["5Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["5Y"].beta !== null
                                  ? fundDetails.risk_parameters[
                                      "5Y"
                                    ].beta.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["5Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["5Y"]
                                  .sharpe_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "5Y"
                                    ].sharpe_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["5Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["5Y"]
                                  .treynor_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "5Y"
                                    ].treynor_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["5Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["5Y"]
                                  .jensens_alpha !== null
                                  ? fundDetails.risk_parameters[
                                      "5Y"
                                    ].jensens_alpha.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["5Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["5Y"]
                                  .information_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "5Y"
                                    ].information_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["5Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["5Y"]
                                  .sortino_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "5Y"
                                    ].sortino_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["5Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["5Y"].r_squared !==
                                  null
                                  ? fundDetails.risk_parameters[
                                      "5Y"
                                    ].r_squared.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                            </div>
                          )}
                          {yearsRatio === "7y" && (
                            <div className="row par_7">
                              <div className="col">
                                {fundDetails.risk_parameters["7Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["7Y"].annual_sd !==
                                  null
                                  ? fundDetails.risk_parameters[
                                      "7Y"
                                    ].annual_sd.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["7Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["7Y"].beta !== null
                                  ? fundDetails.risk_parameters[
                                      "7Y"
                                    ].beta.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["7Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["7Y"]
                                  .sharpe_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "7Y"
                                    ].sharpe_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["7Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["7Y"]
                                  .treynor_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "7Y"
                                    ].treynor_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["7Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["7Y"]
                                  .jensens_alpha !== null
                                  ? fundDetails.risk_parameters[
                                      "7Y"
                                    ].jensens_alpha.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["7Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["7Y"]
                                  .information_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "7Y"
                                    ].information_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["7Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["7Y"]
                                  .sortino_ratio !== null
                                  ? fundDetails.risk_parameters[
                                      "7Y"
                                    ].sortino_ratio.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                              <div className="col">
                                {fundDetails.risk_parameters["7Y"] !==
                                  undefined &&
                                fundDetails.risk_parameters["7Y"].r_squared !==
                                  null
                                  ? fundDetails.risk_parameters[
                                      "7Y"
                                    ].r_squared.toFixed("0")
                                  : "NA"}{" "}
                                %
                              </div>
                            </div>
                          )}
                          <div className="row header_1">
                            <p className="col">SD </p>
                            <p className="col">Beta</p>
                            <p className="col">Sharpe</p>
                            <p className="col">Treynor</p>
                            <p className="col">Alpha </p>
                            <p className="col">Information</p>
                            <p className="col">Sortino</p>
                            <p className="col">R-Squared</p>
                          </div>
                          <div className="row justify-content-center mt-5">
                            <div className="btn-group ">
                              <Button
                                type="button"
                                text="1Y"
                                customClass={`btn border-warning ${
                                  yearsRatio === "1y" ? "al_button_01 " : ""
                                }`}
                                onClick={() =>
                                  this.handleInvestmentYearsRatios("1y")
                                }
                              />
                              <Button
                                type="button"
                                text="3Y"
                                customClass={`btn border-warning ${
                                  yearsRatio === "3y" ? "al_button_01 " : ""
                                }`}
                                onClick={() =>
                                  this.handleInvestmentYearsRatios("3y")
                                }
                              />
                              <Button
                                type="button"
                                text="5Y"
                                customClass={`btn border-warning ${
                                  yearsRatio === "5y" ? "al_button_01 " : ""
                                }`}
                                onClick={() =>
                                  this.handleInvestmentYearsRatios("5y")
                                }
                              />
                              <Button
                                type="button"
                                text="7Y"
                                customClass={`btn border-warning ${
                                  yearsRatio === "7y" ? "al_button_01 " : ""
                                }`}
                                onClick={() =>
                                  this.handleInvestmentYearsRatios("7y")
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-sm-12">
                      <div className="card al_card al_card_2">
                        <div className="card-header title_6">Analytics</div>
                        {fundDetails &&
                          fundDetails.metadata.asset_category !==
                            "Fixed Income" && (
                            <Fragment>
                              <div className="card-body">
                                <div className="row par_7">
                                  <p className="col-sm-4">
                                    Top Stock Holdings{" "}
                                  </p>
                                  <p className="col-sm-4">
                                    Top Sector Holdings{" "}
                                  </p>
                                  <p className="col-sm-4">
                                    Allocation by Market Cap{" "}
                                  </p>
                                </div>
                                <div className="row">
                                  <div className="col-md-4">
                                    {topStockHoldings.map((item, index) => (
                                      <Fragment>
                                        <div className="row" key={index}>
                                          <div className="col-sm-8">
                                            {item.security}
                                          </div>
                                          <div className="col-sm-4 text-right">
                                            {item.holding_perc}%
                                          </div>
                                        </div>
                                        <div className="progress display-inline-block">
                                          <div
                                            className="progress-bar bg_success "
                                            role="progressbar"
                                            style={{
                                              width: `${item.holding_perc}% `,
                                            }}
                                          ></div>
                                        </div>
                                      </Fragment>
                                    ))}
                                  </div>

                                  <div className="col-md-4">
                                    {sector_holding_mf_list.map(
                                      (item, index) => (
                                        <Fragment>
                                          <div className="row" key={index}>
                                            <div className="col-sm-8">
                                              {item.sector}
                                            </div>
                                            <div className="col-sm-4 text-right">
                                              {item.holding_perc}%
                                            </div>
                                          </div>
                                          <div className="progress display-inline-block">
                                            <div
                                              className="progress-bar bg_warning "
                                              role="progressbar"
                                              style={{
                                                width: `${item.holding_perc}% `,
                                              }}
                                            ></div>
                                          </div>
                                        </Fragment>
                                      )
                                    )}
                                  </div>
                                  <div className="col-md-4">
                                    <div className="row">
                                      <div className="col-sm-4">Large cap</div>
                                      <div className="col-sm-8 text-right">
                                        {marketCapDataList.market_cap.market_cap_large.toFixed(
                                          0
                                        )}
                                        %
                                      </div>
                                    </div>
                                    <div className="progress display-inline-block">
                                      <div
                                        className="progress-bar bg_danger"
                                        role="progressbar"
                                        style={{
                                          width: `${marketCapDataList.market_cap.market_cap_large}% `,
                                        }}
                                      ></div>
                                    </div>
                                    <div className="row">
                                      <div className="col-sm-4">Mid cap</div>
                                      <div className="col-sm-8 text-right">
                                        {marketCapDataList.market_cap.market_cap_mid.toFixed(
                                          0
                                        )}
                                        %
                                      </div>
                                    </div>
                                    <div className="progress display-inline-block">
                                      <div
                                        className="progress-bar bg_danger"
                                        role="progressbar"
                                        style={{
                                          width: `${marketCapDataList.market_cap.market_cap_mid}% `,
                                        }}
                                      ></div>
                                    </div>
                                    <div className="row">
                                      <div className="col-sm-4">Small cap</div>
                                      <div className="col-sm-8 text-right">
                                        {marketCapDataList.market_cap.market_cap_small.toFixed(
                                          0
                                        )}
                                        %
                                      </div>
                                    </div>
                                    <div className="progress display-inline-block">
                                      <div
                                        className="progress-bar bg_danger"
                                        role="progressbar"
                                        style={{
                                          width: `${marketCapDataList.market_cap.market_cap_small}% `,
                                        }}
                                      ></div>
                                    </div>
                                    <div className="row">
                                      <div className="col-sm-4">Others cap</div>
                                      <div className="col-sm-8 text-right">
                                        {marketCapDataList.market_cap.market_cap_others.toFixed(
                                          0
                                        )}
                                        %
                                      </div>
                                    </div>
                                    <div className="progress display-inline-block">
                                      <div
                                        className="progress-bar bg_danger"
                                        role="progressbar"
                                        style={{
                                          width: `${marketCapDataList.market_cap.market_cap_others}% `,
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Fragment>
                          )}
                        {fundDetails &&
                          fundDetails.metadata.asset_category ===
                            "Fixed Income" && (
                            <Fragment>
                              <div className="card-body">
                                <div className="row par_7">
                                  <p className="col-sm-4">Top Securities</p>
                                  <p className="col-sm-4">
                                    Allocation by Category
                                  </p>
                                  <p className="col-sm-4">
                                    Allocation by Ratings{" "}
                                  </p>
                                </div>
                                <div className="row">
                                  <div className="col-sm-4">
                                    {security_holding_mf_list.map(
                                      (item, index) => (
                                        <Fragment>
                                          <div className="row mt-1" key={index}>
                                            <div className="col-sm-8">
                                              {item.security}
                                            </div>
                                            <div className="col-sm-4 text-right">
                                              {item.holding_perc}%
                                            </div>
                                          </div>
                                          <div className="progress display-inline-block">
                                            <div
                                              className="progress-bar bg_success"
                                              role="progressbar"
                                              style={{
                                                width: `${item.holding_perc}% `,
                                              }}
                                            ></div>
                                          </div>
                                        </Fragment>
                                      )
                                    )}
                                  </div>

                                  <div className="col-sm-4">
                                    <div className="row mt-1">
                                      <div className="col-sm-4">Corp Debt</div>
                                      <div className="col-sm-8 text-right">
                                        {marketCapDataList.asset_break_up.corporate_debt.toFixed(
                                          0
                                        )}
                                      </div>
                                    </div>
                                    <div className="progress display-inline-block">
                                      <div
                                        className="progress-bar bg_warning"
                                        role="progressbar"
                                        style={{
                                          width: `${marketCapDataList.asset_break_up.corporate_debt}% `,
                                        }}
                                      ></div>
                                    </div>
                                    <div className="row mt-1">
                                      <div className="col-sm-4">G Sec</div>
                                      <div className="col-sm-8 text-right">
                                        {marketCapDataList.asset_break_up.government_securities.toFixed(
                                          0
                                        )}
                                      </div>
                                    </div>
                                    <div className="progress display-inline-block">
                                      <div
                                        className="progress-bar bg_warning"
                                        role="progressbar"
                                        style={{
                                          width: `${marketCapDataList.asset_break_up.government_securities}% `,
                                        }}
                                      ></div>
                                    </div>
                                    <div className="row mt-1">
                                      <div className="col-sm-4">
                                        Cash & Equiv
                                      </div>
                                      <div className="col-sm-8 text-right">
                                        {Number(
                                          marketCapDataList.asset_break_up[
                                            "cash_&_equivalent"
                                          ] +
                                            marketCapDataList.asset_break_up
                                              .cash_management_bill
                                        ).toFixed(0)}
                                      </div>
                                    </div>
                                    <div className="progress display-inline-block">
                                      <div
                                        className="progress-bar bg_warning"
                                        role="progressbar"
                                        style={{
                                          width: `${
                                            marketCapDataList.asset_break_up[
                                              "cash_&_equivalent"
                                            ] +
                                            marketCapDataList.asset_break_up
                                              .cash_management_bill
                                          }% `,
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                  <div className="col-sm-4">
                                    <div className="row mt-1">
                                      <div className="col-sm-4">AAA</div>
                                      <div className="col-sm-8 text-right">
                                        {Number(
                                          marketCapDataList.credit_breakup.aaa
                                        ).toFixed(0)}
                                        %
                                      </div>
                                    </div>
                                    <div className="progress display-inline-block">
                                      <div
                                        className="progress-bar bg_danger"
                                        role="progressbar"
                                        style={{
                                          width: `${marketCapDataList.credit_breakup.aaa}% `,
                                        }}
                                      ></div>
                                    </div>
                                    <div className="row mt-1">
                                      <div className="col-sm-4">AA</div>
                                      <div className="col-sm-8 text-right">
                                        {Number(
                                          marketCapDataList.credit_breakup.aa
                                        ).toFixed(0)}
                                        %
                                      </div>
                                    </div>
                                    <div className="progress display-inline-block">
                                      <div
                                        className="progress-bar bg_danger"
                                        role="progressbar"
                                        style={{
                                          width: `${marketCapDataList.credit_breakup.aa}% `,
                                        }}
                                      ></div>
                                    </div>
                                    <div className="row mt-1">
                                      <div className="col-sm-4">A</div>
                                      <div className="col-sm-8 text-right">
                                        {Number(
                                          marketCapDataList.credit_breakup.a
                                        ).toFixed(0)}
                                        %
                                      </div>
                                    </div>
                                    <div className="progress display-inline-block">
                                      <div
                                        className="progress-bar bg_danger"
                                        role="progressbar"
                                        style={{
                                          width: `${marketCapDataList.credit_breakup.a}% `,
                                        }}
                                      ></div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Fragment>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* <Footer /> */}
                <Seo />
              </Fragment>
            )}
            {!fetching && (
              <div className="text-center">
                <ContentLoader />
              </div>
            )}
          </div>
        </BlockUi>
      </Fragment>
    );
  }
}

export default withRouter(FundDetails);
